export function yTextToBlob(data: string, mime_type: string) {
    return new Blob([data], { type: mime_type });
}

export function yReadFile(file: Blob, as: 'buffer'): Promise<ArrayBuffer>;
export function yReadFile(file: Blob, as: 'string' | 'url' | 'binary'): Promise<string>;
export function yReadFile(file: Blob, as: 'string' | 'buffer' | 'url' | 'binary') {
    return new Promise<ArrayBuffer | string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => { resolve(reader.result as ArrayBuffer | string); };
        reader.onerror = reject;

        if(as == 'buffer')
            reader.readAsArrayBuffer(file);
        else if(as == 'url')
            reader.readAsDataURL(file);
        else if(as == 'binary')
            reader.readAsBinaryString(file);
        else
            reader.readAsText(file);
    });
}

export function yLoadImage(src: string) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const image = new Image;
        image.onload = () => {
            resolve(image);
        };
        image.onerror = (err) => {
            reject(err);
        }
        image.src = src;
    });
}
